import React, { useContext, useEffect } from 'react'
import WizardFlowStep from '@Components/WizardFlow/wizard-flow-step'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import WizardFlow from '@Components/WizardFlow'
import SourcePublisherSelectionStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/SourcePublisherSelectionStep'
import VerifyWorksStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/VerifyWorksStep'
import TargetPublisherSelectionStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/TargetPublisherSelectionStep'
import UploadDocumentStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/UploadDocumentStep'
import AdditionalInfoStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/AdditionalInfoStep'
import TransferNavBar from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/TransferNavBar'
import ReviewStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ReviewStep'
import TransferTypeStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/TransferTypeStep'
import './index.scss'
import ExportCatalogStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ExportCatalogStep'
import ImportCatalogStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ImportCatalogStep'
import ConfirmationStep from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ConfirmationStep'
import ContentHeader from '@Components/ContentHeader'

interface CatalogTransferWizardProps {
    type: 'ACQUISITION' | 'RELINQUISHMENT'
}

const CatalogTransferWizard = ({ type }: CatalogTransferWizardProps) => {
    const { wizardFlowStore, catalogTransferWizardStore } = useContext(StoresContext)

    const acquireFlow: WizardFlowStep[] = [
        {
            stepIndicator: {
                label: 'Action',
            },
            forms: [<TransferTypeStep key="transfer-type-step" />],
            navigationBar: <TransferNavBar />,
            onNextValidation: () => catalogTransferWizardStore.updateCatalogTransfer(),
        },
        {
            stepIndicator: {
                label: 'Acquisition',
            },
            forms: [<SourcePublisherSelectionStep key="acquisition-step" />],
            navigationBar: <TransferNavBar />,
            onNextValidation: () => catalogTransferWizardStore.linkSourcePublisher(),
        },
        {
            stepIndicator: {
                label: 'Select Works',
            },
            forms: [<VerifyWorksStep key="verify-works-step" />],
            navigationBar: <TransferNavBar />,
        },
        {
            stepIndicator: {
                label: 'Export',
            },
            forms: [<ExportCatalogStep key="export-catalog-step" />],
            navigationBar: <TransferNavBar />,
        },
        {
            stepIndicator: {
                label: 'Upload',
            },
            forms: [<ImportCatalogStep key="import-document-step" />],
            navigationBar: <TransferNavBar />,
        },
        {
            stepIndicator: {
                label: 'Select Parties',
            },
            forms: [<TargetPublisherSelectionStep key="select-parties-step" />],
            navigationBar: <TransferNavBar />,
            onNextValidation: () => catalogTransferWizardStore.updateCatalogTransfer(),
        },
        {
            stepIndicator: {
                label: 'Upload',
            },
            forms: [<UploadDocumentStep key="upload-document-step" />],
            navigationBar: <TransferNavBar />,
        },
        {
            stepIndicator: {
                label: 'Effective Date',
            },
            forms: [<AdditionalInfoStep key="other-details-step" />],
            navigationBar: <TransferNavBar />,
            onNextValidation: () => catalogTransferWizardStore.updateCatalogTransfer(),
        },
        {
            stepIndicator: {
                label: 'Review',
            },
            forms: [<ReviewStep key="review-step" />, <ConfirmationStep key="confirm-step" />],
            navigationBar: <TransferNavBar />,
        },
    ]

    const relinquishFlow: WizardFlowStep[] = [
        {
            stepIndicator: {
                label: 'Transfer Type',
            },
            forms: [<TransferTypeStep key="transfer-type-step" />],
            navigationBar: <TransferNavBar />,
        },
        {
            stepIndicator: {
                icon: ICONS.search,
                label: 'Search',
            },
            forms: [<form key={1}>1. Relinquish Search Form</form>],
        },
        {
            stepIndicator: {
                icon: ICONS.workDetails,
                label: 'Enter Work Details',
            },
            forms: [<form key={2}>2. Relinquish Work Details Form</form>],
        },
    ]

    useEffect(() => {
        wizardFlowStore.setFlow(type === 'ACQUISITION' ? acquireFlow : relinquishFlow)
    }, [])

    return (
        <div className="catalog-transfer-wizard">
            <ContentHeader
                title={
                    type === 'ACQUISITION' ? 'Catalog Transfer Tool- Acquiring' : 'Catalog Transfer Tool- Relinquishing'
                }
            />
            <WizardFlow />
        </div>
    )
}

export default CatalogTransferWizard
